var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessCircleLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3841_13669)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37187 5.37187 0 12 0C18.6281 0 24 5.37187 24 12C24 18.6281 18.6281 24 12 24C5.37187 24 0 18.6281 0 12ZM9.675 16.807L18.1008 8.35312C18.4289 8.025 18.4289 7.49062 18.0984 7.16016C17.768 6.83203 17.2336 6.83203 16.9055 7.1625L9.22969 14.8617L7.22813 11.3578C6.99844 10.9523 6.48281 10.8117 6.07734 11.0438C5.67188 11.2734 5.53125 11.7891 5.76328 12.1945L8.31563 16.657C8.47031 16.9312 8.75625 17.0836 9.04922 17.0836C9.18984 17.0836 9.33516 17.0484 9.46641 16.9734C9.54141 16.9312 9.60938 16.8773 9.66562 16.8164L9.675 16.807Z",
    fill: "white",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3841_13669",
    x: -4,
    y: -4,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3841_13669"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3841_13669",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCircleLarge);
export default __webpack_public_path__ + "static/media/success-circle-large.32ad96ba24c28307b7ccf4d368b061c3.svg";
export { ForwardRef as ReactComponent };